import * as B from '@blueprintjs/core';
import React from 'react';

import {ALERT_ERROR_MESSAGES} from 'app/components/Alerts/AlertConfigurationModal';
import {PolicySummary} from 'app/components/Alerts/PolicySummary';
import {AlertFormAction, AlertFormState} from 'app/components/Alerts/useAlertForm';
import {FeatureMultiSelect} from 'app/components/FeatureMultiSelect';
import {ApiFeature} from 'app/modules/Remote/Feature/types';

import cs from '../styles.module.scss';

const checkFeatureSelectionsEqual = (a: number[], b: number[]): boolean => {
  if (a.length !== b.length) return false;
  return a.every((id, i) => id === b[i]);
};

export const FinalizeEnrollmentAlertStep: React.FC<{
  allFeatures: ApiFeature[];
  dispatch: React.Dispatch<AlertFormAction>;
  formEnrolledIds: number[];
  initialSelection: ApiFeature[];
  previousIds: number[];
  currentIds: number[];
  formState: AlertFormState;
  validateNameIsNotDuplicate: (name: string) => boolean;
  disableInputs: boolean;
  projectOverlays: Array<{id: number; name: string}>;
  organizationOverlays: Array<{id: number; name: string}>;
  displayAreaUnit: string;
}> = React.memo(
  ({
    allFeatures,
    dispatch,
    formEnrolledIds,
    initialSelection,
    previousIds,
    currentIds,
    formState,
    validateNameIsNotDuplicate,
    disableInputs,
    projectOverlays,
    organizationOverlays,
    displayAreaUnit,
  }) => {
    const duplicateName = !validateNameIsNotDuplicate(formState.name);

    return (
      <div className={cs.dialogPanel}>
        <B.FormGroup label="Select properties to enroll">
          <FeatureMultiSelect
            features={allFeatures}
            onSelectionUpdate={(selection) => {
              const selectionIDs = selection.map((f) => f.properties.id);
              if (formEnrolledIds && !checkFeatureSelectionsEqual(selectionIDs, formEnrolledIds)) {
                dispatch({
                  type: 'SET_IDS_TO_ENROLL',
                  enrolledIds: selectionIDs,
                });
              }
            }}
            initialSelection={initialSelection}
            placeholder="Click or type here to select properties to enroll in this alert."
            disabled={disableInputs}
          />
        </B.FormGroup>
        <B.FormGroup
          label="Name "
          subLabel={
            duplicateName ? (
              <span style={{color: '#d33'}}>{ALERT_ERROR_MESSAGES.DUPLICATE_NAME}</span>
            ) : undefined
          }
        >
          <B.InputGroup
            intent={duplicateName ? B.Intent.DANGER : B.Intent.NONE}
            value={formState.name}
            placeholder="Enter a descriptive name for your lookout policy"
            onChange={({currentTarget: {value}}) => dispatch({type: 'SET_NAME', name: value})}
            disabled={disableInputs}
          />
        </B.FormGroup>

        <B.FormGroup label="Set a description" labelInfo="(optional)">
          <B.TextArea
            fill={true}
            value={formState.description}
            onChange={({currentTarget: {value}}) =>
              dispatch({type: 'SET_DESCRIPTION', description: value})
            }
            disabled={disableInputs}
          />
        </B.FormGroup>
        <PolicySummary
          formState={formState}
          projectOverlays={projectOverlays}
          organizationOverlays={organizationOverlays}
          displayAreaUnit={displayAreaUnit}
          previousIds={previousIds}
          currentIds={currentIds}
        />
      </div>
    );
  }
);
